<template>
  <CustomModal
    :visible="visible"
    @update:visible="$emit('update:visible', $event)"
    title="Exit Task Autoplay"
    width="32vw"
  >
    <span>Do you want to close the task autoplay?</span>
    <template #footer>
      <a-button class="primary_medium" @click="$emit('confirm')">
        Confirm
      </a-button>
    </template>
  </CustomModal>
</template>

<script setup>
import CustomModal from "@/src/components/CustomModal.vue";

const props = defineProps({
  visible: { type: Boolean, required: true },
});

const emits = defineEmits(["update:visible", "confirm"]);
</script>
